module.exports = __webpack_public_path__ + "images/img-3xerenN.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/leads.jpg
// module id = 1997
// module chunks = 0